import * as React from 'react';
import moment from 'moment';
import type { JsonObject } from '@/app-package';
import { AppointmentDoc } from '@bb/domain/dist/schemas';

import UpcomingAppointmentDetail from './UpcomingAppointmentDetail';
import AppointmentDate from './AppointmentDate';

type AppointmentDetailsGroupProps = {
  appointmentDate: string;
  appointments: JsonObject<AppointmentDoc>[];
};

const AppointmentDetailsGroup = ({
  appointmentDate,
  appointments,
}: AppointmentDetailsGroupProps) => {
  const isToday = (date: string) =>
    moment(date).isSame(moment().format('YYYY-MM-DD'));

  return (
    <div className="row">
      <div className="col-lg-2 col-xs-5">
        <AppointmentDate
          appointmentDate={appointmentDate}
          isActive={isToday(appointmentDate)}
        />
      </div>
      <div className="col-lg-9 col-xs-5">
        {appointments.map(appointment => (
          <div className="row" key={appointment.id}>
            <div className="col-xs-12">
              <UpcomingAppointmentDetail appointment={appointment} />
            </div>
          </div>
        ))}
      </div>
      <div className="col-lg-1 col-xs-2">
        <a
          href={`/get_appointments_instructions#?date=${appointmentDate}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa fa-print"></i>
        </a>
      </div>
    </div>
  );
};

export default AppointmentDetailsGroup;
